"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _lodash2 = _interopRequireDefault(require("lodash.get"));

var _lodash3 = _interopRequireDefault(require("lodash.differenceby"));

var _lodash4 = _interopRequireDefault(require("lodash.isequal"));

var _RecurringCreditsModal = _interopRequireDefault(require("./RecurringCreditsModal"));

var _AllocateCreditsModal = _interopRequireDefault(require("./AllocateCreditsModal"));

require("../styles/_allocate-credits.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AllocateCredits = /*#__PURE__*/function (_Component) {
  _inherits(AllocateCredits, _Component);

  function AllocateCredits(props) {
    var _this;

    _classCallCheck(this, AllocateCredits);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AllocateCredits).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getTeamIndex", (0, _lodash.default)(function (teamId) {
      var teams = _this.props.teams;
      return teams.findIndex(function (team) {
        return team.teamId === teamId;
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "handleUpdateTeam", function (_ref) {
      var updatedTeam = _ref.updatedTeam,
          shouldUpdateParentTeams = _ref.shouldUpdateParentTeams;
      var onUpdateTeams = _this.props.onUpdateTeams;
      var teams = _this.state.teams;

      var teamIndex = _this.getTeamIndex(updatedTeam.teamId);

      var updatedTeams = [].concat(_toConsumableArray(teams.slice(0, teamIndex)), [updatedTeam], _toConsumableArray(teams.slice(teamIndex + 1)));

      _this.setState({
        teams: updatedTeams
      });

      if (shouldUpdateParentTeams) {
        onUpdateTeams(updatedTeams);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateTeamsAndCreditBalance", function (teams, creditBalance) {
      _this.setState({
        teams: teams.map(function (team) {
          var currentBalance = (0, _lodash2.default)(team, 'creditBalance.balance', 0);
          return _objectSpread({}, team, {
            currentBalance: currentBalance
          });
        }),
        creditBalance: creditBalance
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getUpdatedTeams", function () {
      var startingTeams = _this.props.teams;
      var teams = _this.state.teams;
      return (0, _lodash3.default)(teams, startingTeams, 'creditBalance');
    });

    _defineProperty(_assertThisInitialized(_this), "fetchOrgRecurringBalance", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var getOrgRecurringBalance, _ref3, data, error, balance;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getOrgRecurringBalance = _this.props.getOrgRecurringBalance;
              _context.next = 3;
              return getOrgRecurringBalance();

            case 3:
              _ref3 = _context.sent;
              data = _ref3.data;
              error = _ref3.error;

              if (!(!data || error)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              balance = data.getOrgRecurringBalance;

              _this.setState({
                orgRecurringBalance: balance,
                isUnlimited: balance === -1
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onDeleteCreditRule", function (_ref4) {
      var updatedTeam = _ref4.updatedTeam,
          orgRecurringBalance = _ref4.orgRecurringBalance;

      _this.setState({
        orgRecurringBalance: orgRecurringBalance
      }, function () {
        _this.handleUpdateTeam({
          updatedTeam: updatedTeam,
          shouldUpdateParentTeams: true
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCloseSetRecurring", function () {
      _this.setState({
        selectedTeam: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "goToSetRecurring", function (team) {
      return function () {
        _this.setState({
          selectedTeam: team
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onCreditsAllocationChange", function (_ref5) {
      var updatedTeam = _ref5.updatedTeam,
          updatedOrgBalance = _ref5.updatedOrgBalance;
      var creditBalance = _this.state.creditBalance;

      _this.setState({
        creditBalance: _objectSpread({}, creditBalance, {
          balance: updatedOrgBalance
        })
      }, function () {
        _this.handleUpdateTeam({
          updatedTeam: updatedTeam
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAllocateCreditsModalSave", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(updatedCreditBalance) {
        var _this$props, onUpdateOrgBalance, onUpdateTeams, creditBalance, onCreditsUpdated, teams;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props = _this.props, onUpdateOrgBalance = _this$props.onUpdateOrgBalance, onUpdateTeams = _this$props.onUpdateTeams, creditBalance = _this$props.creditBalance, onCreditsUpdated = _this$props.onCreditsUpdated;
                teams = _this.state.teams;
                onUpdateOrgBalance(_objectSpread({}, creditBalance, {}, updatedCreditBalance));
                _context2.next = 5;
                return onUpdateTeams(teams);

              case 5:
                onCreditsUpdated();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref6.apply(this, arguments);
      };
    }());

    _this.state = {
      selectedTeam: void 0,
      creditBalance: props.creditBalance,
      teams: [],
      orgRecurringBalance: 0,
      isUnlimited: false
    };
    return _this;
  }

  _createClass(AllocateCredits, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          teams = _this$props2.teams,
          creditBalance = _this$props2.creditBalance;
      this.updateTeamsAndCreditBalance(teams, creditBalance);
      this.fetchOrgRecurringBalance();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          teams = _this$props3.teams,
          creditBalance = _this$props3.creditBalance;

      if (!(0, _lodash4.default)(teams, prevProps.teams) || !(0, _lodash4.default)(creditBalance, prevProps.creditBalance)) {
        this.updateTeamsAndCreditBalance(teams, creditBalance);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          visible = _this$props4.visible,
          onClose = _this$props4.onClose,
          creditType = _this$props4.creditType,
          onCreditTypeChange = _this$props4.onCreditTypeChange,
          organisationId = _this$props4.organisationId;
      var _this$state = this.state,
          balance = _this$state.creditBalance.balance,
          teams = _this$state.teams,
          isUnlimited = _this$state.isUnlimited,
          selectedTeam = _this$state.selectedTeam,
          orgRecurringBalance = _this$state.orgRecurringBalance;
      var updatedTeams = this.getUpdatedTeams();
      return _react.default.createElement("div", {
        className: "allocate-credits"
      }, _react.default.createElement(_RecurringCreditsModal.default, {
        organisationId: organisationId,
        onSave: this.handleUpdateTeam,
        onClose: this.handleCloseSetRecurring,
        isVisible: Boolean(selectedTeam),
        selectedTeam: selectedTeam,
        orgRecurringBalance: orgRecurringBalance,
        isUnlimited: isUnlimited,
        teams: teams
      }), _react.default.createElement(_AllocateCreditsModal.default, {
        organisationId: organisationId,
        isVisible: visible,
        onClose: onClose,
        onSave: this.onAllocateCreditsModalSave,
        creditType: creditType,
        onCreditTypeChange: onCreditTypeChange,
        isSetRecurringMode: Boolean(selectedTeam),
        orgBalance: balance,
        teams: teams,
        isUnlimited: isUnlimited,
        updatedTeams: updatedTeams,
        onGoToSetRecurring: this.goToSetRecurring,
        onCreditsAllocationChange: this.onCreditsAllocationChange,
        orgRecurringBalance: orgRecurringBalance,
        onDeleteCreditRule: this.onDeleteCreditRule
      }));
    }
  }]);

  return AllocateCredits;
}(_react.Component);

exports.default = AllocateCredits;